import { useCallback, useEffect, useState } from "react"
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import AddProduct from "../../../components/AddProduct";
import { useOutletContext } from "react-router-dom";
import ShowCategory from "../../../components/ShowCategory";
import List from '@mui/material/List';
import { setCategories } from "../../../utils/database";
import { useMediaQuery } from "react-responsive";
import OrderCategories from "../../../components/OrderCategories";
import { setMenuProperty } from "../../../utils/database";

export default function Products() {
    const [userAuth, userData, userMenu, updateUserData, updateUserMenu, setPreventNavigation] = useOutletContext()

    const [openDialog, setOpenDialog] = useState(false)
    const [initialProduct, setInitialProduct] = useState(undefined)

    const isBigScreen = useMediaQuery({ query: '(min-width: 768px)' })

    const filterProducts = useCallback(category => {
        if (userMenu.products) {
            return Object.entries(userMenu.products).filter(product => {
                return product[1].category === category
            })
        } else {
            return []
        }
    }, [userMenu])

    const deleteCategory = useCallback(categoryPosition => {

        let newCategories = [...userMenu.categories]
        newCategories.splice(categoryPosition, 1)

        setCategories(userAuth, userData.menuid, newCategories)
        updateUserMenu()
    }, [userMenu, userAuth, userData, updateUserMenu])

    const orderCategories = useCallback(newCategories => {
        setMenuProperty(userAuth, userData.menuid, 'categories', newCategories)
        updateUserMenu()
    }, [userAuth, userData, updateUserMenu])

    useEffect(() => {
        setOpenDialog(initialProduct ? true : false)
    }, [initialProduct])

    return (
        <>
            <Stack
                direction={isBigScreen ? "row" : "column"}
                justifyContent="space-between"
                alignItems="center"
                gap='15px'
            >

                <Typography variant="h4" component="div" >
                    Categorias
                </Typography>

                {!userMenu ? null : !userMenu.categories ? null :
                    <OrderCategories
                        categories={userMenu.categories}
                        filterProducts={filterProducts}
                        orderCategories={orderCategories}
                    />
                }

                <Button
                    variant="contained"
                    onClick={() => setOpenDialog(true)}
                    fullWidth
                >
                    Agregar un nuevo producto
                </Button>


            </Stack>

            {!userMenu ? null :
                !userMenu.categories || !userMenu.products ? null :
                    <>
                        <List>
                            {
                                Object.entries(userMenu.categories).map(category =>
                                    <ShowCategory
                                        category={category}
                                        products={filterProducts(category[1])}
                                        setInitialProduct={setInitialProduct}
                                        deleteCategory={deleteCategory}
                                        key={category}
                                    />
                                )
                            }
                        </List>
                    </>
            }

            <AddProduct
                openDialog={openDialog}
                setOpenDialog={setOpenDialog}
                userMenu={userMenu}
                userAuth={userAuth}
                userData={userData}
                updateUserMenu={updateUserMenu}
                initialProduct={initialProduct}
                setInitialProduct={setInitialProduct}
                setPreventNavigation={setPreventNavigation}
            />
        </>
    )
}